import { isEmpty } from 'lodash';

export function isDefined<T>(value: T): value is Exclude<T, undefined | null> {
    switch (true) {
        case value === undefined:
        case value === null:
            return false;
        case typeof value === 'string':
            return !!value;
        case typeof value === 'object':
            return !isEmpty(value);
        default:
            return true;
    }
}
